<template>
  <v-flex pt-3>
    <v-card-title>
      <h3 class="halfwhite-text">View all of Your Ovation</h3>
      <h3 class="section-title halfwhite-text">
        Comment List
      </h3> 
    </v-card-title>
    <v-card-text class="card-box">
      <div class="mb-3">
        <v-flex v-if="loader.loading == false">
          <v-card>
            <v-flex>
              <v-card-text>
                <div v-if="config.dashboardCommentList">
                  <v-layout row>
                    <v-flex style="flex-grow:0">
                      <v-chip red-text>
                        <v-avatar>
                          <v-img :src="(activityItem.sourceUser||{}).avatar"></v-img>
                        </v-avatar>
                        <span :style="'color:'+ $store.state.colorScheme.funds.gOvations.accent">-{{(activityItem.transaction||{}).amount}}</span>
                        &nbsp;
                        <v-icon :color="$store.state.colorScheme.funds.gOvations.accent">mdi-coins</v-icon>
                      </v-chip>
                    </v-flex>
                    <v-flex style="flex-grow:0"> 
                      <div style="padding-top:5px;">
                        <v-icon>mdi-play</v-icon>
                      </div>
                    </v-flex>
                    <v-flex style="flex-grow:0">
                      <v-chip class="blue-text">
                        <v-avatar >
                          <v-img :src="(activityItem.targetUser||{}).avatar"></v-img>
                        </v-avatar>
                        <span>{{(activityItem.transaction||{}).amount}}</span>
                        &nbsp;
                        <v-icon>mdi-coins</v-icon>
                      </v-chip>
                    </v-flex>
                  </v-layout>
                  <v-layout style="margin-top:10px;  padding-left:20px;">
                    <v-flex>
                      <strong>{{activityItem.message}}</strong>
                    </v-flex>
                  </v-layout>
                  <v-layout style="margin-top:0px; padding-left:20px;">
                    <v-flex>
                      <span>{{activityItem.description}}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <div v-else>
                  <v-layout style="margin-top:10px;  padding-left:20px;">
                    <v-flex style="font-size: 30px;">
                      <strong>{{activityItem.name}}</strong>
                    </v-flex>
                    <v-flex style="font-size: 30px;">
                      <v-card-text class="ovation-amount" style="text-align: right;">
                        <v-icon :color="$store.state.colorScheme.funds.gOvations.accent" :size="30">mdi-coins</v-icon>
                        <span class="display-2 red-text font-weight-bold">{{activityItem.ovationAmount}}</span>
                      </v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout style="margin-top:0px; padding-left:20px;">
                    <v-flex>
                      <span>{{activityItem.description}}</span>
                      <p v-if="activityItem.fileUrl">Please <a :href="activityItem.fileUrl" target="_blank">click here </a>for the doc.</p>
                    </v-flex>
                  </v-layout>
                </div>
                <div v-if="activityItem.commentList">
                  <v-layout class="mt-3" v-for="(singleComment, indexx) in activityItem.commentList" :key="indexx">
                    <v-flex>
                      <v-card>
                        <v-flex class="comment-flex">
                          <v-avatar size="25" v-if="singleComment.avatar" style="width:50%; height: 50%"><img :src="singleComment.avatar"/></v-avatar>&nbsp;&nbsp;<span class="blue-color" v-if="config.dashboardCommentList">{{singleComment.commentByName}}</span><span class="blue-color" v-else>{{singleComment.userName}}</span>
                          {{singleComment.comment}}
                        </v-flex>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </div>
                <br/>
                <v-pagination v-model="page" :circle="false" :disabled="false" :length="length" next-icon="navigate_next" prev-icon="navigate_before" :page="page" :total-visible="7" @input="next"></v-pagination>
                <v-layout class="mt-3" >
                    <v-flex  style="flex-grow:0" class="mt-2 text-xs-right pr-4">
                        <v-badge right color="transparent">
                          <span slot="badge"><v-icon>mdi-message-text</v-icon></span>
                          <v-avatar size="46px">
                            <v-img :src="$store.state.userSelf.profile.avatar"></v-img>
                          </v-avatar>
                        </v-badge>
                    </v-flex>
                    <v-flex pa-1>
                      <v-text-field outline single-line label="Please add a comment..." v-model="comment"></v-text-field>
                    </v-flex>
                    <v-flex style="flex-grow:0" class="mt-2 pr-4">
                      <v-btn fab dark small :disabled="!comment" @click="addComment()">
                        <v-icon dark>send</v-icon>
                      </v-btn>
                    </v-flex>
                </v-layout>
              </v-card-text>
            </v-flex>
          </v-card>
        </v-flex>
      </div>
      <v-flex>
        <v-dialog v-model="loader.loading" overlay persistent width="300" >
          <Loader :config="loader"></Loader>
        </v-dialog>
      </v-flex>
    </v-card-text>
  </v-flex>
</template>

<script>
  import axios from "axios";
  import Loader from "@/components/Loader";

  export default {
   props:['config', 'bgcolorx'],
   components:{
     Loader
   },
    data () {
      return {
        activityItem: [],
        loader:{
          loading: false
        },
        comment: "",
        page: 1,
        length: 1
      }
    },
    computed:{
    },
    methods: {
      next(page){
        this.loader.loading = true;
        console.log(this.$route.params.id);
        if(this.config.dashboardCommentList){
          var params = {
            sortkey:this.$route.params.id,
            subdomain:this.$store.state.userSelf.activeOrg.subdomain,
            pageIndex:this.page,
            pageSize: 5
          };
        }else{
          var params = {
            id:this.$route.params.id,
            // subdomain:this.$store.state.userSelf.activeOrg.subdomain,
            pageIndex:this.page,
            pageSize: 5
          };
        }
        axios
          // Get the activity stream
          .post(
            this.config.getApiUrl,
            params,
            this.$store.state.axiosConfig
          )
          .then(response => {
            console.log(response);
            this.activityItem = response.data;
            this.loader.loading = false;
            this.length = response.data.totalPages;
            this.page = response.data.pageIndex;
          })
          .catch(e => {
            this.loader.loading = false;          
          });
      },
      addComment(){
        this.loader.loading = true;
        console.log(this.$route.params.id);
        if(this.config.dashboardCommentList){
          var params = {
            sortkey:this.$route.params.id,
            subdomain:this.$store.state.userSelf.activeOrg.subdomain,
            comment: this.comment
          };
        }else{
          var params = {
            bountyId:this.$route.params.id,
            // subdomain:this.$store.state.userSelf.activeOrg.subdomain,
            comment: this.comment
          };
        }
        
        axios
        // Get the activity stream
        .post(
          this.config.addCommentApi,
          params,
          this.$store.state.axiosConfig
        )
        .then(response => {
          if(response.data.status == "OK"){
            this.page = 1;
            this.next(this.page);
            this.comment = "";
            this.$store.commit('replaceSnackbar', {
              message:response.data.message,
              messageType:"success",
            });
          }else{
            this.$store.commit('replaceSnackbar', {
              message:response.data.message,
              messageType:"error",
            });
            this.loader.loading = false;
          }
        }).catch(e => {
          this.loader.loading = false;
          this.$store.dispatch('error401Response', e);
          this.$store.commit('replaceSnackbar', {
            message:e,
            messageType:"error",
          });
          console.log('error');
          console.log(e);
        });
      }
    },
    beforeMount(){
      this.next(this.page);
    },
  }
</script>
